export type HeatmapDataItem = {
    month: string,
    hour: number,
    sumValue: number,
    avgValue: number,
    minValue: number,
    maxValue: number,
}
export type GetHeatmapByIdArgs = {
    objectId: string,
    resourceGroupId: number,
    start: string,
    end: string
}

export enum MeterType {FeedIn = 0, Producer =1, Consumer = 2, FeedOut = 3};
export enum MeterMedium {ElectricityMeter = 0, HeatMeter = 1, ColdMeter = 2, WaterMeter = 3, GasMeter = 4, FuelMeter = 5};

